import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { CreditCard, Loader2 } from "lucide-react";
import { useQuery } from "@tanstack/react-query";
import { creditQueries } from "@/api/credits";

export function BalanceCard({ personaId }: { personaId: string }) {
  const { data: balance, isLoading: isLoadingBalance } = useQuery({
    ...creditQueries.agentBalance(personaId),
  });

  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <CreditCard className="h-5 w-5" />
          Credit Balance
        </CardTitle>
        <CardDescription>View and manage your credit balance</CardDescription>
      </CardHeader>
      <CardContent>
        <div className="grid gap-4">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm font-medium text-muted-foreground">
                Available Credits
              </p>
              <p className="text-3xl font-bold">
                {isLoadingBalance ? (
                  <Loader2 className="h-6 w-6 animate-spin" />
                ) : (
                  (balance?.available_credits.toLocaleString() ?? "0")
                )}
              </p>
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
